import './AzyByteTechLanding.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { HashLink } from "react-router-hash-link";

function Footer(){
return (
<footer className="bg-dark text-white py-5" style={{color:"white"}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 mb-4 mb-lg-0">
              <div className="d-flex align-items-center mb-3">
                <span className="fw-bold fs-4">AzyByte Technologies</span>
              </div>
              <p className="">
                "Engineering excellence in every byte.
                We transform ideas into high-performing platforms, helping businesses scale through expert web development, mobile apps,
                 and optimized cloud infrastructure. Along with that we also build AI chatbots and Automation programs to handle your business
                 queries smoothly."
              </p>
            </div>

            <div className="col-lg-2 mb-4 mb-lg-0">
              <h5 className="mb-3 text-white">Links</h5>
              <ul className="list-unstyled">
                <li className="mb-2 text-white"><a href="/" className="">Home</a></li>
                <li className="mb-2"><a href="/about" className="">About</a></li>
                <li className="mb-2"><a href="/services" className="">Services</a></li>
                <li><a href="/contact" className="">Contact</a></li>
              </ul>
            </div>

            <div className="col-lg-3 mb-4 mb-lg-0">
              <h5 className="mb-3">Services</h5>
              <ul className="list-unstyled">
                <li className="mb-2"><HashLink smooth to="/services#webdev">Web Development</HashLink></li>
                <li className="mb-2"><HashLink smooth to="/services#wordpressdev">Wordpress/Shopify Development</HashLink></li>
                <li className="mb-2"><HashLink smooth to="/services#appdev">App Development</HashLink></li>
                <li className="mb-2"><HashLink smooth to="/services#chatbots">AI Chatbots/Automation</HashLink></li>
                <li className="mb-2"><HashLink smooth to="/services#cloudsol">Cloud Solutions</HashLink></li>
                <li className="mb-2"><HashLink smooth to="/services#uiux">UI/UX</HashLink></li>
                <li className="mb-2"><HashLink smooth to="/services#itconsultancy">IT Consultancy</HashLink></li>
              </ul>
            </div>

            <div className="col-lg-3">
              <h5 className="mb-3">Contact Us</h5>
              <ul className="list-unstyled">
                <li className="mb-2 "><i className="bi bi-geo-alt me-2"></i>3rd Floor,Above Navjivan Electronics,Gurukrupa Society - Pij Road, Nadiad-387002</li>
                <li className="mb-2 "><i className="bi bi-envelope me-2"></i><a href="mailto:contact@azybyte.in">contact@azybyte.in</a></li>
                <li className="mb-2 "><i className="bi bi-phone me-2"></i>Business Inquiries : <a href="tel:+918460444634">+91 8460444634</a></li>
                <li className="mb-2 "><i className="bi bi-phone me-2"></i>Agency(Head) :    <a href="tel:+919998203277">+91 9998203277</a></li>
              </ul>
              <div className="social-icons mt-3">
                <a href="https://linkedin.com/company/azybytetechnologies" className="text-white me-3" aria-label="LinkedIn"><i className="bi bi-linkedin"></i></a>
                <a href="https://instagram.com/azybytetechnologies" className="text-white me-3"  aria-label="Instagram"><i className="bi bi-instagram"></i></a>
                <a href="mailto:contact@azybyte.in" className='text-white' aria-label="Email us"><i class="bi bi-envelope"></i></a>
              </div>
            </div>
          </div>

          <hr className="my-4 bg-secondary" />

          <div className="row">
            <div className="col-md-6 mb-3 mb-md-0">
              <p className=" mb-0">© 2026 AzyByte Technologies. All rights reserved.</p>
            </div>
            <div className="col-md-6 text-md-end">
              <a href="/privacypolicy" className="pt me-3">Privacy Policy</a>
              <a href="/terms" className="pt">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
)

}


export default Footer;